import { MouseEvent } from 'react'
import { Vector } from '../../../../../entity'
import {useSelector} from "react-redux";
import {State} from "../../../../../state";

interface FreehandDrawingViewProps {
    points: Vector[]
    ratioWidth: number
    ratioHeight: number
    width: number
    height: number
    left: number
    top: number
    onClick: () => void
    onMouseDown: (event: MouseEvent) => void
    visible: boolean
    selected: boolean
}

export const FreehandDrawingView = (props: FreehandDrawingViewProps) => {
    const {tool} = useSelector((state: State) => state.editor)

    return (
        <>
            {(() => {
                let objects = []

                if (props.points != null && props.points.length !== 0) {
                    let lineData = ''

                    let firstPos = 0
                    let lastPos = 0
                    let spacerPos = 0

                    //console.log(props.points)

                    for (let i = 0; i < props.points.length; i++) {
                        const point = props.points[i]

                        if (point.flags !== '[SPACER]') {
                            lineData += Number((point.x * props.ratioWidth).toFixed(0)) + ',' + Number((point.y * props.ratioWidth).toFixed(0))
                            lineData += ' '
                        } else {
                            //csak ahhoz kell hogy a path vége szép lekerekített legyen mint mobilon

                            firstPos = spacerPos
                            lastPos = i - 1
                            spacerPos = i + 1

                            var circleStyle = {
                                padding: 0,
                                margin: 0,
                                display: 'inline-block',
                                backgroundColor: props.selected ? 'red' :'white',
                                borderRadius: '50%',
                                width: 20,
                                height: 20,
                                left: props.points[firstPos].x * props.ratioWidth - 10,
                                top: props.points[firstPos].y * props.ratioWidth - 9,
                            }

                            objects.push(<div style={{ position: 'absolute', visibility: !props.visible ? `hidden` : `visible`, ...circleStyle, paddingLeft: '0px', paddingTop: '0px' }}></div>)

                            circleStyle = {
                                padding: 0,
                                margin: 0,
                                display: 'inline-block',
                                backgroundColor: props.selected ? 'red' :'white',
                                borderRadius: '50%',
                                width: 20,
                                height: 20,
                                left: props.points[lastPos].x * props.ratioWidth - 10,
                                top: props.points[lastPos].y * props.ratioWidth - 9,
                            }

                            objects.push(<div style={{ position: 'absolute', visibility: !props.visible ? `hidden` : `visible`, ...circleStyle, paddingLeft: '0px', paddingTop: '0px' }}></div>)

                            const path = (
                                <div style={{ position: 'absolute', paddingLeft: '0px', paddingTop: '0px' }} onMouseDown={props.onMouseDown}>
                                    <svg width={props.width} height={props.height} fill={props.selected ? '#ff0000' : `#ffffff`} stroke={props.selected ? '#ff0000' : `#ffffff`}>
                                        <polyline points={lineData} stroke={props.selected ? '#ff0000' : `#ffffff`} strokeWidth="20" fill="none" strokeLinejoin="round" onClick={props.onClick} style={{ pointerEvents: tool === null ? 'all' : 'unset', visibility: !props.visible ? `hidden` : `visible` }} />
                                    </svg>
                                </div>
                            )

                            lineData = ''

                            objects.push(path)
                        }
                    }
                }

                return objects
            })()}
        </>
    )
}
